import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';

// IMPORTANT: Import the service from the correct path
import { ThemeService } from './services/theme/theme.service';
import { OsintBackgroundPollIndicatorComponent } from './components/common/osint-background-poll-indicator/osint-background-poll-indicator.component';
import { HelpBotWidgetComponent } from './components/common/help-bot-widget/help-bot-widget.component';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    OsintBackgroundPollIndicatorComponent,
    HelpBotWidgetComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'OSINT';
  currentTheme = 'light';
  /** Missing `enableChatbot` in environment → default off (same as false). */
  readonly enableChatbot =
    (environment as { enableChatbot?: boolean }).enableChatbot ?? false;
  private themeSubscription: Subscription = new Subscription();

  constructor(public themeService: ThemeService) {}

  ngOnInit(): void {
    this.themeSubscription.add(
      this.themeService.currentTheme$.subscribe((theme) => {
        this.currentTheme = theme;
        this.themeService.applyTheme(theme);
      }),
    );
  }

  ngOnDestroy(): void {
    this.themeSubscription.unsubscribe();
  }
}
